/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UoMDimension } from '@gh/builder-shared-data';
import { rendererIconByName } from '@gh/common-internal-shared';
import { EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';

import { GridOptions } from 'ag-grid-community';

import { UomListItem } from '../../resources/uom-list-item.model';

@Injectable()
export class UomGridDefinition extends LayoutBasedGridDefinition {

  uomDimensions: EnumDictionary<UoMDimension>;

  columnDefs = {
    dimension1: {
      valueGetter: (params: any) => params.node.data.dimension1 ?
        this.uomDimensions.get(params.node.data.dimension1) : params.node.data.dimension1User,
    },
    dimension2: {
      valueGetter: (params: any) => params.node.data.dimension2 ?
        this.uomDimensions.get(params.node.data.dimension2) : params.node.data.dimension2User,
    },
    dimension3: {
      valueGetter: (params: any) => params.node.data.dimension3 ?
        this.uomDimensions.get(params.node.data.dimension3) : params.node.data.dimension3User,
    },
    usePieces: {
      cellRenderer: (params: any): string => params.node.data.usePieces ? rendererIconByName('done') : '',
    },
  };

  constructor(private route: ActivatedRoute) {
    super();

    const { uomDimensions } = getRouteInitData(route);

    this.uomDimensions = uomDimensions;
  }

  buildGridOptions(): GridOptions {
    return { getRowNodeId: (data: UomListItem) => data.id };
  }
}
